import React from "react";

type HeadingProps<T extends React.ElementType = "h1"> = {
  as?: T;
  className?: string;
  children: React.ReactNode;
} & React.ComponentPropsWithoutRef<T>;

const Heading = <T extends React.ElementType = "h1">({
  as,
  className = "",
  children,
  ...props
}: HeadingProps<T>) => {
  const Tag = as || "h3";

  return (
    <Tag className={className} {...props}>
      {children}
    </Tag>
  );
};

export default Heading;
